import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/AbbiamoIncontratoCompact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddToCalendarMenu"] */ "/app/src/components/AddToCalendarMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApprofondimentiGridBlock"] */ "/app/src/components/ApprofondimentiGridBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventiEsterniBlock"] */ "/app/src/components/EventiEsterniBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventoMediaSections.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventoMediaSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventoPromoBlock"] */ "/app/src/components/EventoPromoBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventsGridBlock"] */ "/app/src/components/EventsGridBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/GalleryBlocks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroCarouselBlock"] */ "/app/src/components/HeroCarouselBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeBlockRefRenderer"] */ "/app/src/components/HomeBlockRefRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/MediaStripBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollReveal"] */ "/app/src/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeakersCloudBlock"] */ "/app/src/components/SpeakersCloudBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/YouTubeFacade.tsx");
